exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub_title[data-v-e4b4af24]{font-size:.18rem;font-family:Roboto-Bold,Roboto;font-weight:bold;color:#000;line-height:.28rem;margin-bottom:.16rem;display:flex;justify-content:space-between}", ""]);

// exports
